module.exports = __webpack_public_path__ + "img/nhsmun.dbedc8a6.svg";